<template>
  <div>
    <Sticky v-model="isStickyHeader">
      <ul
        v-show="isStickyHeader"
        id="bid-sticky-tabs"
        class="tabs hkld-tabs"
        data-tabs
      >
        <div>
          <div
            id="tabs-nav"
            class="tabs-title sticky-tabs-nav"
          >
            <a
              v-checkVisibility
              class="is-active-tab"
              @click="navToTab('#bid-tab-general', $event)"
            >
              {{ $t('tender.generalTab') }}
            </a>
            <a
              v-show="isTender"
              v-checkVisibility
              @click="navToTab('#bid-tab-scope', $event)"
            >
              {{ $t('tender.scopeTab') }}
            </a>
            <a
              v-checkVisibility
              @click="navToTab('#bid-tab-services', $event)"
            >
              {{ $t('tender.sectionTab') }}
            </a>
            <a
              v-checkVisibility
              @click="navToTab('#bid-tab-attachment', $event)"
            >
              {{ $t('tender.attachmentTab') }}
            </a>
            <a
              v-checkVisibility
              @click="navToTab('#bid-tab-tnc', $event)"
            >
              {{ $t('tender.tncTab') }}
            </a>
            <a
              v-show="showQuery"
              v-checkVisibility
              @click="navToTab('#bid-tab-query', $event)"
            >
              {{ $t('summary.query.name') }}
            </a>
          </div>
          <div class="float-right sticky-tender-tab-buttons">
            <slot />
          </div>
        </div>
      </ul>
    </Sticky>
    <div class="create-tender-main">
      <ul
        id="bid-tabs"
        class="row tabs hkld-tabs medium-column-5"
        data-tabs
      >
        <li class="tabs-title is-active column">
          <a
            v-checkVisibility
            href="#bid-tab-general"
          >
            {{ $t('tender.generalTab') }}
          </a>
        </li>
        <li
          v-show="isTender"
          class="tabs-title column"
        >
          <a
            v-checkVisibility
            href="#bid-tab-scope"
          >
            {{ $t('tender.scopeTab') }}
          </a>
        </li>
        <li class="tabs-title column">
          <a
            v-checkVisibility
            href="#bid-tab-services"
          >
            {{ $t('tender.sectionTab') }}
          </a>
        </li>
        <li class="tabs-title column">
          <a
            v-checkVisibility
            href="#bid-tab-attachment"
          >
            {{ $t('tender.attachmentTab') }}
          </a>
        </li>
        <li class="tabs-title column">
          <a
            v-checkVisibility
            href="#bid-tab-tnc"
          >
            {{ $t('tender.tncTab') }}
          </a>
        </li>
        <li
          v-show="showQuery"
          class="tabs-title column"
        >
          <a
            v-checkVisibility
            href="#bid-tab-query"
          >
            {{ $t('summary.query.name') }}
          </a>
        </li>
      </ul>

      <div
        data-tabs-content="bid-tabs"
        class="hkld-tabs-content"
      >
        <div
          id="bid-tab-general"
          class="tabs-panel is-active"
        >
          <div class="grey lighten-5">
            <general
              :general.sync="general"
              :isContractor="true"
              :tenderBidId="currentBidId"
            />
          </div>
        </div>
        <div
          v-show="isTender"
          id="bid-tab-scope"
          class="tabs-panel"
        >
          <scope-of-work :items="general.scopeOfWorks" />
        </div>
        <div
          id="bid-tab-services"
          class="tabs-panel"
        >
          <items-services-bid
            ref="itemsServicesTab"
            :itemServices="service"
            :bidService.sync="bidService"
            :editView="false"
          />
        </div>
        <div
          id="bid-tab-attachment"
          class="tabs-panel"
        >
          <attachments
            :attachment.sync="attachment"
            :tenderBidId="currentBidId"
            :tenderId="general.id"
            :zipPrefix="zipPrefix"
            :attachmentDesc="attachment.description"
            :editView="false"
          />
        </div>
        <div
          id="bid-tab-tnc"
          class="tabs-panel"
        >
          <div class="grey lighten-5">
            <terms-conditions
              ref="termsConditionsTab"
              :isContractorView="true"
              :tenderId="general.id"
              :totalFee="bidService.totalFee"
              :tncInfo.sync="tncInfo"
              :editView="false"
              :isTender="isTender"
              :zipName="zipNames.terms"
            />
          </div>
        </div>
        <div
          id="bid-tab-query"
          class="tabs-panel"
        >
          <div class="grey lighten-5">
            <tender-query-accordion v-if="showQuery" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapMutations, mapGetters, mapActions } from 'vuex'

import General from '@/modules/tenders/view/General'
import TenderQueryAccordion from '@/modules/tenders/queries/TenderQueryAccordion'
import ScopeOfWork from '@/modules/tenders/view/ScopeOfWork'
import TermsConditions from '@/modules/tenders/TermsConditions'
import ItemsServicesBid from '@/modules/tenders/view/ItemsServicesBid'
import Attachments from '@/modules/vendors/bids/Attachments'
import TenderTabsContainer from '@/modules/tenders/TenderTabsContainer'

import * as bidApi from '@/api/bids/request'
import { getAttachments } from '@/api/docs/request'
import { getZipNames } from '@/store/modules/tenders'
import mutationTypes from '@/store/mutation-types'
import dateUtil from '@/utils/dateUtil'
import EventBus from '@/utils/eventBus'
import notification from '@/utils/notification'
import Sticky from '@/controls/Sticky'

import bidMixin from '@/pages/tenders/bidMixin'

function getDefaultData () {
  return {
    active: 'mobile-tabls-general',
    tender: {
      general: { tenderType: 'Tender' },
    },
    bid: {},
    general: {},
    service: [],
    attachment: {
      description: '',
      files: [],
    },
    scopeOfWorks: {
      generalDesc: '',
      generalSpec: '',
      particularDesc: '',
    },
    text: 'This is a tab component',

    showMessage: false,
    alert: false,
    isInfo: true,
    isError: false,
    message: '',
    bidService: {},
    tncInfo: {},
    isTender: true,
    isStickyHeader: false,
  }
}

export default {
  components: {
    General,
    ItemsServicesBid,
    TermsConditions,
    ScopeOfWork,
    Attachments,
    TenderQueryAccordion,
    TenderTabsContainer,
    Sticky,
  },
  mixins: [bidMixin],
  props: {
    tenderBidId: {
      type: String,
    },
  },
  data: getDefaultData,
  methods: {
    navToTab (tabElem, event) {
      $('#bid-tabs').foundation('selectTab', tabElem, false)
      $(event.target).siblings().removeClass('is-active-tab')
      $(event.target).addClass('is-active-tab')
      let tabPosition = $('#bid-tabs').offset().top
      $(window).scrollTop(Number(tabPosition))
    },
    reset (keep) {
      const def = getDefaultData()
      def[keep] = this[keep]
      Object.assign(this.$data, def)
    },
    async initTenderBid () {
      if (!this.currentBidId || this.currentBidId === null) return
      const response = await bidApi.getBidById(this.currentBidId)
      if (response) {
        if (response.tender) {
          this.general = Object.assign(response.tender)
          this.tender.general = this.general
          this.attachment.description = this.tender.general.attachmentDescription
          this.attachment.files = await this.loadFiles()
          this.isTender = !(this.general.tenderType === 'ITQ')
          this.scopeOfWorks =
            this.tender.scopeOfWorks
              ? this.tender.scopeOfWorks : this.scopeOfWorks
        }
        if (this.general.service) {
          this.tender.service = this.general.service
          this.service = this.tender.service
        }
        this.setTermsVersion({termsVersion: this.general.termsVersion})
        if (response.bid) {
          const bid = { ...this.currentBid, ...response.bid }
          if (response.bid.content) {
            this.bidService = response.bid.content.service
            this.tncInfo = response.bid.content.tncInfo
          }
          this.setCurrentBid({ bid: lodash.cloneDeep(bid) })
        }
      }
    },
    rerender () {
      this.reset()
      this.initTenderBid()
      $('#bid-tabs').foundation('selectTab', '#bid-tab-general', false)
    },
    ...mapMutations('tenders', {
      updateTenderPathField: mutationTypes.TENDER_UPDATE_PATH_FIELD,
      setBidId: mutationTypes.TENDER_CURRENT_BID_ID,
      setCurrentBid: mutationTypes.TENDER_SET_CURRENT_BID,
    }),
    ...mapActions('tenders', [
      'createQuery',
      'setTermsVersion',
    ]),
    async loadFiles () {
      const files = await getAttachments(this.general.id)
      return files
    },
    async populateCurrentTender () {
      this.updateTenderPathField({
        path: ['general'],
        newValue: lodash.cloneDeep(this.general),
      })
      if (!this.general.documents) {
        this.updateTenderPathField({
          path: ['general', 'documents'],
          newValue: await this.loadFiles(),
        })
      }
      this.updateTenderPathField({
        path: ['service'],
        newValue: lodash.cloneDeep(this.service),
      })
      this.updateTenderPathField({
        path: ['scopeOfWorks'],
        newValue: lodash.cloneDeep(this.scopeOfWorks),
      })
    },
    async exportPDF (type) {
      if (!type) return
      const vendorFiles = await getAttachments(this.currentBidId) || []
      const request = lodash.cloneDeep({
        general: { ...this.general, documents: this.attachment.files || [], firstIssuedDate: this.firstIssuedDate },
        itemServices: this.service,
        attachments: { files: vendorFiles, description: this.attachment.description },
        tncInfo: this.tncInfo,
        issueDateArr: this.issueDateArr,
        bid: { ...this.currentBid },
      })

      await bidApi.exportContractorPDF(type, request, this.bidService)
    },

    async startQuery () {
      try {
        await this.createQuery()
        $('#bid-tabs').foundation('selectTab', '#bid-tab-query', false)
      } catch (err) {
        notification.handleResponseError(err)
      }
    },
  },
  async mounted () {
    await this.initTenderBid()
    this.currentBidTabs = new Foundation.Tabs($('#bid-tabs'))

    const tabs = $('#bid-tabs li a') || []
    if (tabs.length > 0) {
      $('#bid-tabs li a')[0].click()
    }

    EventBus.$on('refresh:bid-detail', async () => {
      this.rerender()
    })
  },
  destroyed () {
    if (this.currentBidTabs) {
      this.currentBidTabs.destroy()
    }
    EventBus.$off('refresh:bid-detail')
  },
  computed: {
    ...mapGetters('tenders', ['currentBid', 'currentBidId', 'currentTender']),
    firstIssuedDate () {
      let firstIssuedDate = deep(this.currentTender, 'general.issuedDate')
      if (this.currentTender.general.version > 0 && deep(this.currentTender, 'firstIssuedVersion.data')) {
        firstIssuedDate = deep(this.currentTender, 'firstIssuedVersion.data.issuedDate')
      }
      return firstIssuedDate ? dateUtil.formatDate(firstIssuedDate, 'MMM dd') : null
    },
    zipNames () {
      return getZipNames(this.tender)
    },
    zipPrefix () {
      const prNumber = deep(this.tender, 'general.prNumber')
      return prNumber ? `Tender_${prNumber}` : 'Tender'
    },
    showQuery () {
      return (this.currentBid && this.currentBid.queries && this.currentBid.queries.length > 0)
    },
  },
  watch: {
    currentBidId (val) {
      if (val) {
        this.initTenderBid()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/tender/view";
@import "~styles/tabsContainer";
@import "~styles/stickyBtn";

.tender-head .button {
  margin-left: 12px;
}

.callout {
  margin: 0;
  padding: 0.8rem 1.3rem;
}

input.is-invalid-input {
  background-color: #f9ecea!important;
}
#bid-sticky-tabs {
  background: #ebebeb;
}
</style>
